var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMulogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 279.009,
    height: 75,
    viewBox: "0 0 279.009 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "MU",
    transform: "translate(0 59)",
    fill: "#ac33ac",
    fontSize: 60,
    fontFamily: "Trenda-Heavy, Trenda",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MU")), /*#__PURE__*/React.createElement("text", {
    id: "Metamorphosis_University",
    "data-name": "Metamorphosis University",
    transform: "translate(114.009 32.07)",
    fill: "#717171",
    fontSize: 23,
    fontFamily: "Trenda-Semibold, Trenda",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Metamorphosis"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 28
  }, "University")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulogo);
export default __webpack_public_path__ + "static/media/mulogo.1764338f4fe545fdf92e764145e8b949.svg";
export { ForwardRef as ReactComponent };